
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ABarcodeActionsComponent from './ABarcodeActionsComponent';
import { ScannedBarcodeDetailsViewModel} from 'Api/CoreApi';
import { Prop } from 'vue-property-decorator';

@Component({
    template: '#barcode-details-template'
})
export class BarcodeDetailsComponent extends ABarcodeActionsComponent {
    
    @Prop({default: -1})
    public tableIndex: number;

    @Prop()
    public details: ScannedBarcodeDetailsViewModel;

    created(){
    
    }

    get extendedClassName() : string{
        return this.getTableRowIdentifier(this.tableIndex) + (this.details && this.details.isValid ? ' barcode-valid' : '');
    }
}
Vue.component('barcode-details', BarcodeDetailsComponent);